// extracted by mini-css-extract-plugin
export default {"cls1":"C5tTjtxpojPYAJrXK0Vq","cls2":"xfbYq8OzV6L4t4sAIBH3 C5tTjtxpojPYAJrXK0Vq"};